import { useEffect } from 'react';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';

export const ReadinessTracker = () => {
	useEffect(() => {
		if (typeof window !== 'undefined') {
			window.__JIRA_READY_STATUS = {
				started: true,
				loaded: false,
				onhold: true,
			};
		}
	}, []);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const onPageReady = () => {
				window.__JIRA_READY_STATUS.onhold = false;
			};
			window.addEventListener('UFO_FINISH_INTERACTION', onPageReady);
			return () => {
				window.removeEventListener('UFO_FINISH_INTERACTION', onPageReady);
			};
		}
	}, []);

	const [{ hasLoaded }] = usePageLoadedSubscriber();

	useEffect(() => {
		if (hasLoaded) {
			if (typeof window !== 'undefined') {
				// we track "loaded" status as jira "loading end"
				window.__JIRA_READY_STATUS.loaded = true;
			}
		}
	}, [hasLoaded]);

	return null;
};
